enum ReportType {
  REQUESTS = "REQUESTS",
  SHIPMENTS = "SHIPMENTS",
  CHARGECODES = "CHARGECODES",
  QUOTES = "QUOTES",
  INVOICES = "INVOICES",
  QUICK_REQUEST = "QUICK_REQUEST",
}

export default ReportType;
